import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol viewBox=\"0 0 8 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download\">\n<path d=\"M7.5 3.5H5.5V0.5H2.5V3.5H0.5L4 7L7.5 3.5ZM0.5 8V9H7.5V8H0.5Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol